import React from 'react';
import ItemPage0 from "../components/ItemPages/ItemPage0";
import ItemPage1 from "../components/ItemPages/ItemPage1";
import ItemPage2 from "../components/ItemPages/ItemPage2";
import ItemPage3 from "../components/ItemPages/ItemPage3";
import ItemPage4 from "../components/ItemPages/ItemPage4";
import ItemPage5 from "../components/ItemPages/ItemPage5";
import ItemPage6 from "../components/ItemPages/ItemPage6";
import ItemPage7 from "../components/ItemPages/ItemPage7";
import queryString from 'query-string'
import ItemPage8 from '../components/ItemPages/ItemPage8';
import ItemPageX from '../components/ItemPages/ItemPageX';

const pages = {
    item0: ItemPage0,
    item1: ItemPage1,
    item2: ItemPage2,
    item3: ItemPage3,
    item4: ItemPage4,
    item5: ItemPage5,
    item6: ItemPage6,
    item7: ItemPage7,
    item8: ItemPage8,
    itemX: ItemPageX
};

export default class ItemPage extends React.Component {

    constructor(props) {
		super(props);
		this.state = {};
        //console.log("location:", this.props.location.search) ;
    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    render() {
        let PageComponent = ItemPage0;
        const queryParams=queryString.parse(this.props.location.search);
        const id=queryParams.id;
        if(pages["item" + id]){
            PageComponent = pages["item" + id];
        }
        else{
            PageComponent = pages["itemX"];
        }

        return(
            <div style={{paddingBottom:30}}>
                <PageComponent id={id}></PageComponent>
            </div>
        )
    }
}